import { FC } from 'react'

type Props = {
  text: string
  className?: string
}

export const Text: FC<Props> = ({ text, className }) => {
  return (
    <div
      className={`font-notoSans font-medium text-textPink text-[13px] leading-[31.2px] ${className}`}
    >
      {text}
    </div>
  )
}
